



























import Vue from 'vue'

type Props = {
  value: number
  max: number
  rules: string | object
}

type Computed = {
  localValue: number
}

type Methods = {
  plus: () => void
  minus: () => void
}

export default Vue.extend<{}, Methods, Computed, Props>({
  inheritAttrs: false,
  name: 'XQuantityInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      required: false,
      default: 99,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        let input = Math.floor(value)
        if (input < 0) {
          input = 0
        } else if (input > this.max) {
          input = this.max
        }
        this.$emit('input', input)
      },
    },
  },
  methods: {
    plus() {
      this.localValue = this.value + 1
    },
    minus() {
      this.localValue = this.value - 1
    },
  },
})
